export function openModal() {
    $('.open-modal').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const modal = document.querySelector('#modal-form');

        if (modal) {
            modal.showModal();
            $('body').addClass('modal');
            modal.addEventListener('click', handleBackdropClick);
        }
    });
}


function handleBackdropClick(e) {
    const modal = document.querySelector('#modal-form');

    if (modal) {
        if (e.target === modal) {
            modal.close();
            $('body').removeClass('modal');

            modal.removeEventListener('click', handleBackdropClick);
        }
    }
}

export function submitForm() {
    const form = $('.wpcf7');
    const modal = document.querySelector('#modal-form');
    const modalSuccess = document.querySelector('#modal-success');
    const closeButton = $('#close-success');

    form.on('wpcf7mailsent', function () {
        modal.close();  // Закрытие модалки
        modalSuccess.showModal();  // Открытие модалки успеха

        // Добавляем обработчик клика на кнопку закрытия модалки
        closeButton.on('click', handleClickCloseButton);
    });
}

function handleClickCloseButton(e) {
    const modalSuccess = document.querySelector('#modal-success');

    // Проверяем, что клик был по кнопке закрытия
    if (e.target === document.querySelector('#close-success')) {
        modalSuccess.close();  // Закрытие модалки успеха
        $('body').removeClass('modal');  // Убираем класс для body

        // Убираем обработчик события клика
        $('#close-success').off('click', handleClickCloseButton);
    }
}